import PageProtectedLayout from "../../../../components/Page/PageProtectedLayout.jsx";
import SelectDateBones from "./SelectDateBones.jsx";
import { useTranslation } from '../../../../language';

export default function BloodBonesWelcome() {

  const { t } = useTranslation();

return (

    <PageProtectedLayout

      headline={t('page_hl_bones')}
      specify={t('page_sp_bones_health')}

      >

      {/* Main Page Content */}

       <SelectDateBones />


    </PageProtectedLayout>

  );
}
